export default "__VITE_ASSET__CDTXIBxN__"